export default {
  // 页面标题和面包屑
  'pages.decoration.title': 'Decoration Report Management',
  'pages.decoration.breadcrumb.person': 'Personnel Management',
  'pages.decoration.breadcrumb.decoration': 'Decoration Report',

  // 副标题配置
  'pages.decoration.subtitle.canEnterEarly': 'After approval, you can enter',
  'pages.decoration.subtitle.hoursEnter': 'hours early, if it exceeds',
  'pages.decoration.subtitle.hoursCannotEnter': 'hours, you will not be able to enter the community',

  // 按钮
  'pages.decoration.button.settings': 'Settings',

  // 标签页
  'pages.decoration.tabs.registered': 'Registered',
  'pages.decoration.tabs.inProgress': 'In Progress',
  'pages.decoration.tabs.completed': 'Completed',

  // 模态框
  'pages.decoration.modal.config.title': 'Decoration Time Configuration',
  'pages.decoration.modal.config.save': 'Save',
  'pages.decoration.modal.config.cancel': 'Cancel',

  // 表单标签
  'pages.decoration.form.beforeHours.label': 'Early Entry Time (Hours)',
  'pages.decoration.form.beforeHours.placeholder': 'Please enter early entry time',
  'pages.decoration.form.beforeHours.required': 'Please enter early entry time',
  'pages.decoration.form.beforeHours.range': 'Please enter a number between 0-24',

  'pages.decoration.form.afterHours.label': 'Timeout Limit (Hours)',
  'pages.decoration.form.afterHours.placeholder': 'Please enter timeout limit',
  'pages.decoration.form.afterHours.required': 'Please enter timeout limit',
  'pages.decoration.form.afterHours.range': 'Please enter a number between 1-168',

  // 消息
  'pages.decoration.message.configUpdateSuccess': 'Configuration updated successfully',
  'pages.decoration.message.configUpdateFailed': 'Configuration update failed',

  // 表格相关
  'pages.decoration.table.title': 'Decoration Report Management',
  'pages.decoration.table.columns.houseInfo': 'Property Information',
  'pages.decoration.table.columns.ownerName': 'Owner Name',
  'pages.decoration.table.columns.qrcode': 'QR Code',
  'pages.decoration.table.columns.decorationName': 'Decoration Supervisor',
  'pages.decoration.table.columns.decorationPhone': 'Supervisor Phone',
  'pages.decoration.table.columns.decorationCompany': 'Decoration Company',
  'pages.decoration.table.columns.workerCount': 'Number of Workers',
  'pages.decoration.table.columns.startDate': 'Decoration Start Date',
  'pages.decoration.table.columns.endDate': 'Decoration End Date',
  'pages.decoration.table.columns.status': 'Status',
  'pages.decoration.table.columns.createdTime': 'Created Time',
  'pages.decoration.table.columns.action': 'Action',

  // 按钮
  'pages.decoration.button.create': 'New Decoration Report',
  'pages.decoration.button.view': 'View',
  'pages.decoration.button.edit': 'Edit',
  'pages.decoration.button.delete': 'Delete',
  'pages.decoration.button.batchDelete': 'Batch Delete',
  'pages.decoration.button.close': 'Close',

  // 状态
  'pages.decoration.status.notStarted': 'Not Started',
  'pages.decoration.status.inProgress': 'In Progress',
  'pages.decoration.status.completed': 'Completed',
  'pages.decoration.status.unknown': 'Unknown',

  // 详情模态框
  'pages.decoration.detail.title': 'Decoration Report Details',
  'pages.decoration.detail.sections.houseInfo': 'Property Information',
  'pages.decoration.detail.sections.ownerInfo': 'Owner Information',
  'pages.decoration.detail.sections.decorationInfo': 'Decoration Information',
  'pages.decoration.detail.sections.systemInfo': 'System Information',

  // 字段标签
  'pages.decoration.detail.fields.buildingName': 'Building Name',
  'pages.decoration.detail.fields.floor': 'Floor',
  'pages.decoration.detail.fields.houseNumber': 'House Number',
  'pages.decoration.detail.fields.ownerName': 'Owner Name',
  'pages.decoration.detail.fields.ownerPhone': 'Owner Phone',
  'pages.decoration.detail.fields.ownerEmail': 'Owner Email',
  'pages.decoration.detail.fields.decorationName': 'Decoration Supervisor',
  'pages.decoration.detail.fields.decorationPhone': 'Supervisor Phone',
  'pages.decoration.detail.fields.decorationCompany': 'Decoration Company',
  'pages.decoration.detail.fields.workerCount': 'Number of Workers',
  'pages.decoration.detail.fields.decorationStatus': 'Decoration Status',
  'pages.decoration.detail.fields.startDate': 'Decoration Start Date',
  'pages.decoration.detail.fields.endDate': 'Decoration End Date',
  'pages.decoration.detail.fields.createdTime': 'Created Time',
  'pages.decoration.detail.fields.updatedTime': 'Updated Time',

  // 编辑/创建表单
  'pages.decoration.form.create.title': 'New Decoration Report',
  'pages.decoration.form.edit.title': 'Edit Decoration Report',
  'pages.decoration.form.submit.create': 'Create',
  'pages.decoration.form.submit.update': 'Update',
  'pages.decoration.form.submit.cancel': 'Cancel',

  // 表单分区
  'pages.decoration.form.sections.houseInfo': 'Property Information',
  'pages.decoration.form.sections.decorationInfo': 'Decoration Information',
  'pages.decoration.form.sections.remarks': 'Remarks',

  // 表单字段
  'pages.decoration.form.fields.houseInfo.label': 'Property Information',
  'pages.decoration.form.fields.houseInfo.placeholder': 'Please select property',
  'pages.decoration.form.fields.houseInfo.search': 'Search',
  'pages.decoration.form.fields.houseInfo.select': 'Auto-filled after property selection',
  'pages.decoration.form.fields.houseInfo.required': 'Please select property',

  'pages.decoration.form.fields.ownerInfo.label': 'Owner Name',
  'pages.decoration.form.fields.ownerInfo.placeholder': 'Auto-filled after property selection',

  'pages.decoration.form.fields.decorationName.label': 'Decoration Supervisor',
  'pages.decoration.form.fields.decorationName.placeholder': 'Please enter supervisor name',
  'pages.decoration.form.fields.decorationName.required': 'Please enter supervisor name',
  'pages.decoration.form.fields.decorationName.maxLength': 'Supervisor name cannot exceed 50 characters',

  'pages.decoration.form.fields.decorationPhone.label': 'Supervisor Phone',
  'pages.decoration.form.fields.decorationPhone.placeholder': 'Please enter supervisor phone',
  'pages.decoration.form.fields.decorationPhone.required': 'Please enter supervisor phone',

  'pages.decoration.form.fields.decorationCompany.label': 'Decoration Company',
  'pages.decoration.form.fields.decorationCompany.placeholder': 'Please enter decoration company',
  'pages.decoration.form.fields.decorationCompany.required': 'Please enter decoration company',
  'pages.decoration.form.fields.decorationCompany.maxLength': 'Company name cannot exceed 100 characters',

  'pages.decoration.form.fields.workerCount.label': 'Number of Workers',
  'pages.decoration.form.fields.workerCount.placeholder': 'Please enter number of workers',
  'pages.decoration.form.fields.workerCount.required': 'Please enter number of workers',

  'pages.decoration.form.fields.decorationTime.label': 'Decoration Time',
  'pages.decoration.form.fields.decorationTime.placeholder': ['Start Time', 'End Time'],
  'pages.decoration.form.fields.decorationTime.required': 'Please select decoration time',

  'pages.decoration.form.fields.remarks.label': 'Remarks',
  'pages.decoration.form.fields.remarks.placeholder': 'Please enter remarks',

  // 消息提示
  'pages.decoration.message.create.success': 'Decoration report created successfully',
  'pages.decoration.message.create.failed': 'Creation failed, please try again later',
  'pages.decoration.message.update.success': 'Decoration report updated successfully',
  'pages.decoration.message.update.failed': 'Update failed, please try again later',
  'pages.decoration.message.delete.success': 'Deleted successfully',
  'pages.decoration.message.delete.failed': 'Deletion failed',
  'pages.decoration.message.batchDelete.success': 'Batch deletion successful',
  'pages.decoration.message.batchDelete.failed': 'Batch deletion failed',
  'pages.decoration.message.houseSelect.success': 'Property information auto-filled',
  'pages.decoration.message.qrCode.configError': 'QR code URL configuration incomplete',
  'pages.decoration.message.qrCode.downloadSuccess': 'QR code downloaded',
  'pages.decoration.message.qrCode.copySuccess': 'QR code copied to clipboard',
  'pages.decoration.message.qrCode.copyFailed': 'Copy failed, please use download function',
  'pages.decoration.message.qrCode.elementNotFound': 'QR code element not found',
  'pages.decoration.message.qrCode.copyFailedAlternative': 'Copy failed, please use download function or try manual operation',
  'pages.decoration.message.listLoadFailed': 'Failed to load decoration report list',

  // 确认对话框
  'pages.decoration.confirm.delete': 'Are you sure you want to delete this decoration report?',
  'pages.decoration.confirm.batchDelete': 'Are you sure you want to delete the selected {count} records?',
  'pages.decoration.confirm.delete.okText': 'Confirm',
  'pages.decoration.confirm.delete.cancelText': 'Cancel',

  // 二维码相关
  'pages.decoration.qrCode.title': 'Decoration Report QR Code',
  'pages.decoration.qrCode.openLink': 'Open Link',
  'pages.decoration.qrCode.copy': 'Copy QR Code',
  'pages.decoration.qrCode.download': 'Download QR Code',
  'pages.decoration.qrCode.linkLabel': 'Link URL:',

  // 表格分页
  'pages.decoration.table.pagination.total': 'Total {total} records',

  // Tooltip
  'pages.decoration.tooltip.viewDetail': 'View Details',
  'pages.decoration.tooltip.edit': 'Edit',
  'pages.decoration.tooltip.delete': 'Delete',
  'pages.decoration.tooltip.generateQrCode': 'Generate QR Code',

  // Warning messages
  'pages.decoration.warning.selectRecords': 'Please select records to delete',
};
